export var FL = {
  alt: 'fantasy-land/alt',
  ap: 'fantasy-land/ap',
  bimap: 'fantasy-land/bimap',
  chain: 'fantasy-land/chain',
  chainRec: 'fantasy-land/chainRec',
  map: 'fantasy-land/map',
  of: 'fantasy-land/of',
  zero: 'fantasy-land/zero'
};

export var ordinal = ['first', 'second', 'third', 'fourth', 'fifth'];

export var namespace = 'fluture';
export var name = 'Future';
export var version = 5;

export var $$type = namespace + '/' + name + '@' + version;
